import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContext } from '../context/dialog.context';
import AlertDialog from './confirmations/AlertDialog';
import ConfirmationDialog from './confirmations/ConfirmationDialog';
export default () => {
  const {
    MsgAlertDialog,
    setMsgAlertDialog,
    MsgConfirmDialog,
    setMsgConfirmDialog,
    CallBackConfirmDialog,
    setCallBackConfirmDialog,
    titleDialog,
  } = useContext(DialogContext);
  const { t } = useTranslation();
  return (
    <>
      {MsgAlertDialog && (
        <AlertDialog
          title={titleDialog || t('Message')}
          subText={MsgAlertDialog}
          onClose={() => {
            setMsgAlertDialog('');
            if (CallBackConfirmDialog) {
              if (CallBackConfirmDialog.action) {
                if (CallBackConfirmDialog.param) {
                  CallBackConfirmDialog.action(CallBackConfirmDialog.param);
                } else {
                  CallBackConfirmDialog.action();
                }
              }
              setCallBackConfirmDialog({ action: null, param: null });
            }
          }}
        />
      )}
      {MsgConfirmDialog && (
        <ConfirmationDialog
          title={titleDialog || t('Confirmation')}
          subText={MsgConfirmDialog}
          onClose={(confirmed) => {
            setMsgConfirmDialog('');
            if (!confirmed) return false;
            if (CallBackConfirmDialog) {
              if (CallBackConfirmDialog.action) {
                if (CallBackConfirmDialog.param) {
                  CallBackConfirmDialog.action(CallBackConfirmDialog.param);
                } else {
                  CallBackConfirmDialog.action();
                }
              }
              setCallBackConfirmDialog({ action: null, param: null });
            }
          }}
        />
      )}
    </>
  );
};
